import DesignTokens from '@tableau/design-tokens';
import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export namespace UserSettingsHelper {
  const firstColumnDiv: React.CSSProperties = {
    width: '150px',
    paddingLeft: '0px',
    flexShrink: 0
  };

  const secondColumn: React.CSSProperties = {
    height: '16px',
    margin: '1px 12px 1px 48px',
    borderTop: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
    width: '800px',
  };

  export const getSectionDividerLine = (): JSX.Element => {
    return (
        <div style={{display: 'flex'}}>
          <div style={firstColumnDiv}></div>
          <div style={secondColumn}></div>
        </div>
    );
  };
}
